module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/ico_gradient/mission-ico-gradient-bf79a3c547ea6b59e8a378296af1cfa2.svg";